export enum TimeFrequencyMs {
  Hour = 1000 * 60 * 60 * 1,
  Day = 1000 * 60 * 60 * 24,
}
